import ProjectPresetsApplyComponent from './presets-apply.component'

export default ProjectPresetsApplyComponent
